import React from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'

import colors from '@settings/styleSettings'
import Text from './Text'
import { View, StyleSheet, Image } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  imageContainer: {
    display: 'flex',
    backgroundColor: colors.grayBackground,
    borderRadius: '12px',
  },
  title: {
    fontSize: 12,
    color: colors.strongGray,
  },
  required: {
    color: colors.strongRed,
    fontSize: 12,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: 20,
    gap: 8
  },
  image: {
    width: '30vh',
    height: '30vh',
    borderRadius: '12px',
  },
})

const CardImage = ({ title, image }) => {
  return (
    <View style={styles.container}>
      <View style={styles.labelContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.required}>*</Text>
      </View>
      <View style={styles.imageContainer}>
        <Image src={`data:image/jpeg;base64,${image}`} style={styles.image} />
      </View>
    </View>
  )
}

CardImage.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default CardImage
